import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Clock, BarChart2, Languages, CheckCircle } from "lucide-react";
import { EXERCICE_API_ROUTE, CHALLENGE_EXO_API_ROUTE } from "../../routes/api/api_routes";

const EvaluationDetails = () => {
  // const { langage } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("access");

  const [exercices, setExercices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const niveau = state?.niveau;
  const techId = state?.techId;
  const techName = state?.techName;

  useEffect(() => {
    if (!niveau || !techId) {
      console.error("Technologie ou niveau manquant.");
      navigate("/evaluation"); // redirection de secours
      return;
    }

    const fetchFilteredExercices = async () => {
      try {
        const res = await fetch(
          `${EXERCICE_API_ROUTE}?technology=${techId}&niveau=${niveau.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        setExercices(data.data || []);
      } catch (error) {
        console.error("Erreur de récupération des exercices filtrés :", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFilteredExercices();
  }, [niveau, techId, token]);

  const estimatedTime = exercices.reduce(
    (acc, exo) => acc + (exo.resolution_time || 0),
    0
  );

  if (isLoading) {
    return <div className="text-center mt-10">Chargement…</div>;
  }

  console.log("Temps estimé total :", estimatedTime);
  console.log(exercices)
  return (
    <div className="min-h-screen flex flex-col items-center pb-10">
      <h1 className="text-4xl font-bold text-center mt-4 mb-10 capitalize">
        {techName} : Évaluation préalable
      </h1>

      <div className="flex flex-col md:flex-row gap-10 max-w-5xl w-full px-6">
        {/* Colonne gauche */}
        <div className="bg-white shadow-lg rounded-xl p-6 w-full md:w-1/3 border">
          <h2 className="text-xl font-bold text-orange-500 mb-6">
            Compétences en programmation
          </h2>
          <div className="space-y-4 text-gray-700">
            <div className="flex items-center gap-3">
              <Clock className="text-orange-500" size={20} />
              <p>
                Temps : <span className="font-semibold">{estimatedTime} min</span>
              </p>
            </div>
            <div className="flex items-center gap-3">
              <BarChart2 className="text-orange-500" size={20} />
              <p>
                Niveau : <span className="font-semibold">{niveau.name}</span>
              </p>
            </div>
            <div className="flex items-center gap-3">
              <Languages className="text-orange-500" size={20} />
              <p>
                Langue : <span className="font-semibold">Français</span>
              </p>
            </div>
          </div>
        </div>

        {/* Colonne droite */}
        <div className="bg-white shadow-lg rounded-xl p-6 w-full md:w-2/3 border">
          <h2 className="text-xl font-bold mb-4">Sommaire du test :</h2>
          <p className="text-gray-600 mb-6">
            Ce test évalue les compétences {techName} niveau {niveau.name}.
          </p>

          <div className="grid grid-cols-2 gap-4 mb-6">
            {[
              "Routage et traitement des requêtes",
              "Gestion des erreurs",
              "Structures de données",
              "Manipulation de fichiers",
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-md"
              >
                <CheckCircle className="text-green-500" size={18} />
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
  disabled={isLoading || exercices.length === 0}
  className={`px-8 py-2 rounded-full transition ${
    isLoading || exercices.length === 0
      ? "bg-gray-400 text-white cursor-not-allowed"
      : "bg-black text-white hover:bg-gray-800"
  }`}
  onClick={async () => {
    if (isLoading || exercices.length === 0) return;

    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (!user || !user.id) {
      alert("Utilisateur non authentifié");
      return;
    }

    const payload = {
      technologie: techId,
      niveau: niveau.id,
      user: user.id,
    };

    try {
      const res = await fetch(CHALLENGE_EXO_API_ROUTE, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.id) {
        const techSlug = techName?.toLowerCase().replace(/\s+/g, "-");

        // ✅ estimatedTime sera bon maintenant
        navigate(`/evaluation/${techSlug}/pratique/${techId}/${niveau.id}/${data.id}`, {
          state: {
            techId,
            mode: "evaluation",
            estimatedTime: estimatedTime, // ✅ correct maintenant
          },
        });
      } else {
        console.error("Erreur lors de la création du challenge profile", data);
        alert("Erreur lors de la création du challenge profile.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      alert("Erreur réseau lors de la création du challenge profile.");
    }
  }}
>
  Débuter
</button>

            {/* <button
  className="px-8 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition"
  onClick={async () => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (!user || !user.id) {
      alert("Utilisateur non authentifié");
      return;
    }

    const payload = {
      technologie: techId,
      niveau: niveau.id,
      user: user.id,
    };

    try {
      const res = await fetch(CHALLENGE_EXO_API_ROUTE, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.id) {
        // 🔁 Correction ici
        const techSlug = techName?.toLowerCase().replace(/\s+/g, "-");
        // navigate(`/evaluation/${techSlug}/pratique/${techId}/${niveau.id}/${data.id}`, {
        //   state: { techId },
        // });
        navigate(`/evaluation/${techSlug}/pratique/${techId}/${niveau.id}/${data.id}`, {
          state: {
            techId,
            // niveau,
            mode: "evaluation", // ✅ ici
            estimatedTime: estimatedTime, // optionnel pour le timer
          },
        });

      } else {
        console.error("Erreur lors de la création du challenge profile", data);
        alert("Erreur lors de la création du challenge profile.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      alert("Erreur réseau lors de la création du challenge profile.");
    }
  }}
>
  Débuter
</button> */}


          </div>
        </div>
      </div>
    </div>
  );
};

export default EvaluationDetails;
